import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

type AOA = any[][];
@Component({
    selector: 'bulk-data',
    templateUrl: 'bulk-data.html',
    styleUrls: ['bulk-data.scss'],
    // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BulkData implements OnInit {
    toggle() {
        var element = document.getElementById('unclean');
        element!.classList.toggle('show');
        var ele = document.getElementById('tgl');
        ele!.classList.toggle('noshow');
        var ele1 = document.getElementById('clean');
        ele1!.classList.toggle('noshow');
    }

    onFileChange(evt: any) {
        // this.files = Object.keys(pFileList).map((key: any) => pFileList[key]);
        /* wire up file reader */
        const target: DataTransfer = <DataTransfer>evt.target;
        if (target.files.length !== 1)
            throw new Error('Cannot use multiple files');
        const reader: FileReader = new FileReader();
        reader.onload = (e: any) => {
            /* read workbook */
            // const bstr: string = e.target.result;
            // const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

            // /* grab first sheet */
            // const wsname: string = wb.SheetNames[0];
            // const ws: XLSX.WorkSheet = wb.Sheets[wsname];

            // /* save data */
            // this.data1 = <AOA>XLSX.utils.sheet_to_json(ws, { header: 1 });
        };
        reader.readAsBinaryString(target.files[0]);
        //

        this._snackBar.open('Successfully upload!', 'Close', {
            duration: 2000,
        });
    }

    export(): void {
        /* generate worksheet */
        // const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(this.data1);

        // /* generate workbook and add the worksheet */
        // const wb: XLSX.WorkBook = XLSX.utils.book_new();
        // XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

        // /* save to file */
        // XLSX.writeFile(wb, this.fileName);
    }

    constructor(private _snackBar: MatSnackBar) {}
    ngOnInit() {}

    // onNoClick(): void {
    //   this.dialogRef.close();
    //   public dialogRef: MatDialogRef<VideoData>,
    //   @Inject(MAT_DIALOG_DATA) public data: DialogData,
    // }

    data1: AOA = [
        [1, 2],
        [3, 4],
    ];
    // wopts: XLSX.WritingOptions = { bookType: 'xlsx', type: 'array' };
    // fileName: string = 'unCleanData.xlsx';
}
